import { useEffect, useRef } from "react";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster, toast } from "sonner";
import { api } from "@/lib/api";
import Landing from "@/pages/Landing";
import EstimationWizard from "@/pages/EstimationWizard";
import ReportPage from "@/pages/ReportPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ConfidentialitePage from "@/pages/ConfidentialitePage";
import MandatPage from "@/pages/MandatPage";
import RdvPage from "@/pages/RdvPage";
import VendrePage from "@/pages/VendrePage";

function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => navigate("/admin", { state: { user: r.data }, replace: true }))
      .catch((err) => {
        const d = err.response?.data?.detail;
        toast.error(typeof d === "string" ? d : "Connexion Google refusée.");
        navigate("/admin", { replace: true });
      });
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0B0D]">
      <p data-testid="auth-callback-loading" className="font-mono text-xs uppercase tracking-[0.3em] text-stone-500">
        Connexion sécurisée…
      </p>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/estimation" element={<EstimationWizard />} />
      <Route path="/rapport/:id" element={<ReportPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/confidentialite" element={<ConfidentialitePage />} />
      <Route path="/mandat/:id" element={<MandatPage />} />
      <Route path="/rdv/:id" element={<RdvPage />} />
      <Route path="/vendre" element={<VendrePage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster theme="dark" position="top-center" />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
